<template>
    <div class="upload_img">
        <div class="header">{{configData.header}}</div>
        <div class="title">{{configData.title}}</div>
        <div class="box">
            <el-upload
                    style="width: 70px;height: 70px;"
                    class="single-image"
                    list-type="single-image"
                    :on-success="(value) => uploadSuccess(index, value)"
                    :show-file-list="false"
                    :action="app_url + '/store/uploader/upload'">
                <img :src="configData.url"  style="width: 70px;height: 70px;" alt="" v-if="configData.url">
                <div class="upload-box" style="width: 70px;height: 70px;" v-else>
                    <el-icon class="iconfont el-icon-camera" size="36" />
                </div>
            </el-upload>
            <span class="iconfont icondel_1" @click.stop="bindDelete" v-if="configData.url && configData.type"></span>
        </div>
        <div>
            <el-dialog
                    v-model="modalPic"
                    title="上传图片"
                    width="1000px"
                    :z-index="1000"
                    :before-close="closeDialog">
                <fileImages
                        @getPic="getPic"
                        :isChoice="isChoice"></fileImages>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import fileImages from "@/components/fileImages/index.vue";

    export default {
        name: "editorimage",
        components: {
            fileImages
        },
        props: {
            configData: {
                type: Object,
                default: {}
            },
        },
        data() {
            return {
                modalPic: false,
                isChoice: 1,
            }
        },
        methods: {
            // 点击商品图
            modalPicTap(tit, index) {
                this.modalPic = true;
            },
            uploadSuccess(key, res, file) {
                this.$nextTick(() => {
                    this.configData.url = res.data.fileInfo.external_url;
                })
            },
            // 删除
            bindDelete (item, index) {
                this.configData.url = '';
            },
            closeDialog: function () {
                this.modalPic = false;
            }
        }
    }
</script>

<style scoped lang="less">
    .header{
        font-size: 14px;
        color: #000;
    }
    .title{
        margin-bottom: 10px;
        padding-bottom: 10px;
        border-bottom:1px solid rgba(0,0,0,0.05);
        font-size:12px;
        color:#999;
    }
    .box {
        width: 60px;
        height: 60px;
        margin-bottom: 10px;
        position: relative;
        .icondel_1 {
            position: absolute;
            top: -8px;
            right: -8px;
            font-size: 25px;
            color: #999;
        }
        img {
            width: 100%;
            height: 100%;
        }
    }
    .upload-box {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 60px;
        height: 60px;
        background: #ccc;
    }
</style>
